import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vueHeadful from 'vue-headful';

Vue.config.productionTip = false
var VueScrollTo = require('vue-scrollto');
Vue.component('vue-headful', vueHeadful);

Vue.use(VueScrollTo)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
